import React from "react";

export default function CoinDataItem({ id, name, price, change24Hr, marketCap, supply, showHistory }) {
    return (
        <div className="coindataitem row">
            <div className="coinDLText leftText">{name}</div>
            <div className="coinDLText">{parseFloat(price).toFixed(6)} $</div>
            <div className="coinDLText">{parseFloat(change24Hr).toFixed(2)} %</div>
            <div className="coinDLText">{parseFloat(marketCap).toFixed(2)} $</div>
            <div className="coinDLText">{parseFloat(supply).toFixed(2)}</div>
            <div className="coinDLText"><button className="historyButton" onClick={() => showHistory(id)}> history</button></div>
        </div>
    )
}